import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortLinksContainer',
  standalone: false,
})
export class SortLinksContainerPipe implements PipeTransform {
  transform(items: any[]): any[] {
    return this.sortItems(items).map((item) => {
      return {
        ...item,
        links: this.sortItems(item.links),
      };
    });
  }

  private sortItems(list: any[]) {
    return list.sort((a, b) => {
      if (a.label < b.label) {
        return -1;
      }
      if (b.label < a.label) {
        return 1;
      }
      return 0;
    });
  }
}
